
$( document ).ready(function() {

    let classic_blank = "https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_3x240_KLASIK_-_BLANK.jpg?v=1642857202";
    let linis_blank = "https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_3x240_LINIS_7016.jpg?v=1642857202";

    let linis=[];
    linis['7016-3x240-basic']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_3x240_LINIS_7016.jpg?v=1642857202";
    linis['7016-3x240-d2']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_3x240_LINIS_-_D2.jpg?v=1642857202";
    linis['7016-3x240-d4']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_3x240_LINIS_-_D4.jpg?v=1642857202";
    linis['7016-3x240-d6']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_3x240_LINIS_-_D6.jpg?v=1642857202";

    linis['7016-2x240-basic']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_2x240_7016_7016_s.jpg?v=1643988478";
    linis['7016-2x240-d2']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_2x240_7016_D2_s.jpg?v=1643988478";
    linis['7016-2x240-d4']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_2x240_7016_D4_s.jpg?v=1643988478";
    linis['7016-2x240-d6']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_2x240_7016_D6_s.jpg?v=1643988478";

    linis['7016-4x120-basic']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_4x120_7016_7016_s.jpg?v=1643988547";
    linis['7016-4x120-d2']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_4x120_7016_D2_s.jpg?v=1643988547";
    linis['7016-4x120-d4']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_4x120_7016_D4_s.jpg?v=1643988547";
    linis['7016-4x120-d6']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_4x120_7016_D6_s.jpg?v=1643988547";

    linis['7016-3x120-basic']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_3x120_7016_7016_s.jpg?v=1643988565";
    linis['7016-3x120-d2']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_3x120_7016_D2_s.jpg?v=1643988564";
    linis['7016-3x120-d4']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_3x120_7016_D4_s.jpg?v=1643988564";
    linis['7016-3x120-d6']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_3x120_7016_D6_s.jpg?v=1643988564";

    linis['7016-2x120-basic']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_2x120_7016_7016_s.jpg?v=1643988582";
    linis['7016-2x120-d2']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_2x120_7016_D2_s.jpg?v=1643988582";
    linis['7016-2x120-d4']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_2x120_7016_D4_s.jpg?v=1643988582";
    linis['7016-2x120-d6']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_2x120_7016_D6_s.jpg?v=1643988582";

    linis['7016-4x240-basic']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_4x240_7016_7016_s.jpg?v=1643988600";
    linis['7016-4x240-d2']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_4x240_7016_D2_s.jpg?v=1643988601";
    linis['7016-4x240-d4']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_4x240_7016_D4_s.jpg?v=1643988600";
    linis['7016-4x240-d6']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_LINIS_4x240_7016_D6_s.jpg?v=1643988600";

    linis['7016-3x240-basic-link']="/products/styleout-linis-3x240-7016";
    linis['7016-3x240-d2-link']="/products/styleout-linis-3x240-d2";
    linis['7016-3x240-d4-link']="/products/styleout-linis-3x240-d4";
    linis['7016-3x240-d6-link']="/products/styleout-linis-3x240-d6";

    linis['7016-2x240-basic-link']="/products/styleout-linis-2x240-7016";
    linis['7016-2x240-d2-link']="/products/styleout-linis-2x240-d2";
    linis['7016-2x240-d4-link']="/products/styleout-linis-2x240-d4";
    linis['7016-2x240-d6-link']="/products/styleout-linis-2x240-d6";

    linis['7016-4x120-basic-link']="/products/styleout-linis-4x120-7016";
    linis['7016-4x120-d2-link']="/products/styleout-linis-4x120-d2";
    linis['7016-4x120-d4-link']="/products/styleout-linis-4x120-d4";
    linis['7016-4x120-d6-link']="/products/styleout-linis-4x120-d6";

    linis['7016-3x120-basic-link']="/products/styleout-linis-3x120-7016";
    linis['7016-3x120-d2-link']="/products/styleout-linis-3x120-d2";
    linis['7016-3x120-d4-link']="/products/styleout-linis-3x120-d4";
    linis['7016-3x120-d6-link']="/products/styleout-linis-3x120-d6";

    linis['7016-2x120-basic-link']="/products/styleout-linis-2x120-7016";
    linis['7016-2x120-d2-link']="/products/styleout-linis-2x120-d2";
    linis['7016-2x120-d4-link']="/products/styleout-linis-2x120-d4";
    linis['7016-2x120-d6-link']="/products/styleout-linis-2x120-d6";

    linis['7016-4x240-basic-link']="/products/styleout-linis-4x240-7016";
    linis['7016-4x240-d2-link']="/products/styleout-linis-4x240-d2";
    linis['7016-4x240-d4-link']="/products/styleout-linis-4x240-d4";
    linis['7016-4x240-d6-link']="/products/styleout-linis-4x240-d6";

    linis['link-7016-basic-kljuc']="/products/styleout-linis-3x240-7016";
    linis['link-7016-basic-streha']="/products/styleout-linis-3x240-7016";
    linis['link-7016-d2-kljuc']="/products/styleout-linis-3x240-d2";
    linis['link-7016-d2-streha']="/products/styleout-linis-3x240-d2";
    linis['link-7016-d4-kljuc']="/products/styleout-linis-3x240-d4";
    linis['link-7016-d4-streha']="/products/styleout-linis-3x240-d4";
    linis['link-7016-d6-kljuc']="/products/styleout-linis-3x240-d6";
    linis['link-7016-d6-streha']="/products/styleout-linis-3x240-d6";

    let dimensions = [];
    dimensions['3x240'] = "https://cdn.shopify.com/s/files/1/0617/4569/2920/files/styleout5_903461de-23ce-46c3-8c43-f68fcce9c1b0.png?v=1646993505";
    dimensions['2x240'] = "https://cdn.shopify.com/s/files/1/0617/4569/2920/files/styleout4.png?v=1643211714";
    dimensions['4x240'] = "https://cdn.shopify.com/s/files/1/0617/4569/2920/files/styleout6.png?v=1643211714";

    dimensions['3x120'] = "https://cdn.shopify.com/s/files/1/0617/4569/2920/files/styleout2.png?v=1643211714";
    dimensions['2x120'] = "https://cdn.shopify.com/s/files/1/0617/4569/2920/files/styleout1.png?v=1643211714";
    dimensions['4x120'] = "https://cdn.shopify.com/s/files/1/0617/4569/2920/files/styleout3.png?v=1643211713";



    let classic=[];
    classic['7016-3x240-basic']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_3x240_KLASIK_-_BLANK.jpg?v=1642857202";
    classic['7016-3x240-qubis']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_3x240_KLASIK_-_QUBIS.jpg?v=1642857202";
    classic['7016-3x240-tomo']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_3x240_KLASIK_-_TOMO.jpg?v=1642857202";

    classic['7016-2x240-basic']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_BLANK_2x240_7016_7016_s.jpg?v=1643988477";
    classic['7016-2x240-qubis']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_QUBIS_2x240_7016_7016_s.jpg?v=1643988478";
    classic['7016-2x240-tomo']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_TOMO_2x240_7016_7016_s.jpg?v=1643988478";

    classic['7016-3x120-basic']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_BLANK_3x120_7016_7016_s.jpg?v=1643988564";
    classic['7016-3x120-qubis']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_QUBIS_3x120_7016_7016_s.jpg?v=1643988564";
    classic['7016-3x120-tomo']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_TOMO_3x120_7016_7016_s.jpg?v=1643988564";

    classic['7016-4x120-basic']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_BLANK_4x120_7016_7016_s.jpg?v=1643988547";
    classic['7016-4x120-qubis']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_QUBIS_4x120_7016_7016_s.jpg?v=1643988547";
    classic['7016-4x120-tomo']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_TOMO_4x120_7016_7016_s.jpg?v=1643988547";

    classic['7016-2x120-basic']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_BLANK_2x120_7016_7016_s.jpg?v=1643988582";
    classic['7016-2x120-qubis']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_QUBIS_2x120_7016_7016_s.jpg?v=1643988582";
    classic['7016-2x120-tomo']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_TOMO_2x120_7016_7016_s.jpg?v=1643988582";

    classic['7016-4x240-basic']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_BLANK_4x240_7016_7016_s.jpg?v=1643988600";
    classic['7016-4x240-qubis']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_QUBIS_4x240_7016_7016_s.jpg?v=1643988600";
    classic['7016-4x240-tomo']="https://cdn.shopify.com/s/files/1/0617/4569/2920/files/Dukin_StyleOUT_TOMO_4x240_7016_7016_s.jpg?v=1643988600";



    classic['7016-3x240-basic-link']="/products/styleout-classic-3x240-blank";
    classic['7016-3x240-qubis-link']="/products/styleout-classic-3x240-qubis";
    classic['7016-3x240-tomo-link']="/products/styleout-classic-3x240-tomo";

    classic['7016-2x240-basic-link']="/products/styleout-classic-2x240-blank";
    classic['7016-2x240-qubis-link']="/products/styleout-classic-2x240-qubis";
    classic['7016-2x240-tomo-link']="/products/styleout-classic-2x240-tomo";

    classic['7016-3x120-basic-link']="/products/styleout-classic-3x120-blank";
    classic['7016-3x120-qubis-link']="/products/styleout-classic-3x120-qubis";
    classic['7016-3x120-tomo-link']="/products/styleout-classic-3x120-tomo";

    classic['7016-4x120-basic-link']="/products/styleout-classic-4x120-blank";
    classic['7016-4x120-qubis-link']="/products/styleout-classic-4x120-qubis";
    classic['7016-4x120-tomo-link']="/products/styleout-classic-4x120-tomo";

    classic['7016-2x120-basic-link']="/products/styleout-classic-2x120-blank";
    classic['7016-2x120-qubis-link']="/products/styleout-classic-2x120-qubis";
    classic['7016-2x120-tomo-link']="/products/styleout-classic-2x120-tomo";

    classic['7016-4x240-basic-link']="/products/styleout-classic-4x240-blank";
    classic['7016-4x240-qubis-link']="/products/styleout-classic-4x240-qubis";
    classic['7016-4x240-tomo-link']="/products/styleout-classic-4x240-tomo";

    classic['link-7016-basic-kljuc']="/products/styleout-classic-3x240-blank";
    classic['link-7016-basic-streha']="/products/styleout-classic-3x240-blank";
    classic['link-7016-qubis-kljuc']="/products/styleout-classic-3x240-qubis";
    classic['link-7016-qubis-streha']="/products/styleout-classic-3x240-qubis";
    classic['link-7016-tomo-kljuc']="/products/styleout-classic-3x240-tomo";
    classic['link-7016-tomo-streha']="/products/styleout-classic-3x240-tomo";

    //check cookie
    let cookie_page = sessionStorage.getItem('pageview');
    if(cookie_page == 7 && $(".step1")[0]){
        //stigao je do 7, importuj mu sve i prebaci ga na stranu 7
        let splited = sessionStorage.getItem('choosed').split("|");
        $("#model").val(splited[0]);
        $("#colorshooen").val(splited[1]);
        $("#doorchoosen").val(splited[2]);
        $("#binsize").val(splited[3]);
        $("#nobins").val(splited[4]);
        $("#imagechoosen").val(splited[5]);

        modelname=splited[0];
        doorname=$("#doorchoosen").val();

        if(modelname=="linis"){
            $(".classicdoors").hide();
            $(".linisdoors").show();
            $(".classicshow").hide();
        }
        else if(modelname=="classic"){
            $(".linisdoors").hide();
            $(".classicdoors").show();
            $(".linisshow").hide();
        }

        $(".modelname").each(function( index ) {
            $(this).html(modelname.toUpperCase());
        });

        $("#doorname").html(splited[2].toUpperCase());

        //select door type
        $(".doorfinalcoose").find('.doorchoose').each(function( index ) {
            if($(this).data('door')==doorname){
                $(this).addClass('selected');
            }
            else{
                $(this).removeClass('selected');
            }
        });

        $(".step1").hide();
        $(".step2").hide();
        $(".step3").hide();
        $(".step4").hide();
        $(".step5").hide();
        $(".step6").hide();
        setTimeout(function(){
            $(".step7").show();
        },500);
        showstep7();

        makeimage();
        makelink();
    }

    //popup
    $('body').on('click','#modal-success-main-content', function(e) {
    //ocp__modal__btn__XJPJfr0EXQsYdmolbgI95
    //$('html').on('click','#modal-success-main-content button', function(e) {
        let hreflink = $('.viewproductlink').attr('href');
        window.location.href = hreflink;
    });

    //modal-signup
    $('html').on('click','.closeandfinish', function(e) {
        e.preventDefault();
        let hreflink = $(this).attr('href');
        let productlink = $('.viewproductlink').attr('href');
            window.location.href = productlink;
    });

    //configurator
    $(".gotostep").on("click", function(){
        let view = $(this).data('view');
        let step = $(this).data('step');

        if(step==6 && view==5){
            step=7;
        }
        if(step==6 && view==7){
            step=5;
        }
       if(step==4){
          step=5;
        }

        if(typeof step !== "undefined"){
            //setcookie
            sessionStorage.setItem("pageview", step);

        }
        //copy model
        let modelcopy = $("#modelview").html();

        if(view<=3){
            $(".importmodelview").each(function( index ) {
                $(this).html(modelcopy);
            });
        }

       
      
        $(".step"+view).hide();
        if(step!=3){
            $(".step"+step).show();
            if(step==7){
                showstep7();
            }
        }
        else{
        
            showstep3();
        }
    });

    //choose model
    $(".catname").on("click", function(e){
        e.preventDefault();
        let modelname=$(this).data('model');
        $("#model").val(modelname);
        $("#doorchoosen").val('basic');

        //door model on/off
        if(modelname=="linis"){
            $(".linisshow").show();
            $(".classicshow").hide();
            $(".classicdoors").hide();
            $(".linisdoors").show();
        }
        else if(modelname=="classic"){
            $(".linisshow").hide();
            $(".classicshow").show();
            $(".linisdoors").hide();
            $(".classicdoors").show();
        }

         $(".step2").hide();
        showstep3();
    });

    $(".modelnamechoose").on("click", function(){
        let prevname =  $("#model").val();
        let modelname=$(this).data('name');
        $("#model").val(modelname);

        $(".modelname").each(function( index ) {
            $(this).html(modelname.toUpperCase());
        });

        if(prevname != modelname){
            // ako nije kao staro, promeni sliku, door,...
            if(modelname=="linis"){
                $(".classicdoors").hide();
                $(".linisdoors").show();
                $("#doorchoosen").val('basic');

            }
            else if(modelname=="classic"){
                $(".linisdoors").hide();
                $(".classicdoors").show();
                $("#doorchoosen").val('basic');
            }

            let doorname = $("#doorchoosen").val();
            $("#doorname").html(doorname.toUpperCase());

            //select door type
            $(".doorfinalcoose").find('.doorchoose').each(function( index ) {
                if($(this).data('door')==doorname){
                    $(this).addClass('selected');
                }
                else{
                    $(this).removeClass('selected');
                }
            });
        }

        $(".modelnamechoose").each(function( index ) {
            if($(this).data('name')==modelname){
                $(this).addClass('selected');
            }
            else{
                $(this).removeClass('selected');
            }
        });

        $(".finalchoosemodel").hide();

        makelink();
        makeimage();
    });

    $(".doorchoose").on("click", function(){
        let self = $(this);

        $(".doorchoose").each(function( index ) {
            $(this).removeClass('selected');
        });
        self.addClass('selected');

        $("#doorchoosen").val(self.data('door'));

        makeimage();
        makelink();
    });

    $(".lockiing").on("click", function(){
        let self = $(this);
        $(".lockiing").each(function( index ) {
            if($(this).data('equipment')==self.data('equipment')){
                $(this).addClass('selected');
            }
            else{
                $(this).removeClass('selected');
            }
        });

        $("#equipmentchoosen").val(self.data('equipment'));

        makelink();
    });

    $(".opencolors").on('click', function(){
        let self = $(this);
        let colorchoose = $(".colorchoose");
        if(colorchoose.hasClass("nooptions")){}
        else{
            if(colorchoose.hasClass('opened')){

                self.addClass('selected');
                colorchoose.removeClass('opened');

                $(".finalcolor").find('.color').each(function( index ) {
                    if($(this).hasClass("selected")){
                    }
                    else{
                        $(this).hide();
                    }
                });
            }
            else{
                colorchoose.addClass('opened');

                $(".finalcolor").find('.color').each(function( index ) {
                    $(this).removeClass('selected');
                    $(this).show();
                });
            }
        }

        makelink();
    });

    $(".opendoors").on('click', function(){
        let self = $(this);
        let colorchoose = $(".doorfinalcoose");

            if(colorchoose.hasClass('opened')){
                $("#doorname").show();
                self.addClass('selected');
                colorchoose.removeClass('opened');

                $(".finaldoors").find('.opendoors').each(function( index ) {
                    if($(this).hasClass("selected")){
                    }
                    else{
                        $(this).hide();
                    }
                });
                changedoor();
            }
            else{
                colorchoose.addClass('opened');
                $("#doorname").hide();
                $(".finaldoors").find('.opendoors').each(function( index ) {
                    $(this).removeClass('selected');
                    $(this).show();
                });
            }
        makelink();
    });

    $(".opendoors-helper").on('click', function(){
        let self = $(this);
        let colorchoose = $(".doorfinalcoose");

        if(colorchoose.hasClass('opened')){
            $("#doorname").show();
            self.addClass('selected');
            colorchoose.removeClass('opened');

            $(".finaldoors").find('.opendoors').each(function( index ) {
                if($(this).hasClass("selected")){
                }
                else{
                    $(this).hide();
                }
            });
            changedoor();
        }
        else{
            colorchoose.addClass('opened');
            $("#doorname").hide();
            $(".finaldoors").find('.opendoors').each(function( index ) {
                $(this).removeClass('selected');
                $(this).show();
            });
        }
        makelink();
    });

    $(".step7").on('click','.modelchoosen', function(){
        $(".finalchoosemodel").toggle();
    });

    $(".choosebinnumber").on('click', function(){
        let self = $(this);
        let value = $(this).data('value');
        let option = $(this).data('option');

        $(".choosebinnumber").each(function () {
            if($(this).data('option')==option){
                $(this).removeClass('selected');
            }
        });
        self.addClass('selected');

        if(option == "litraza"){
            $("#binsize").val(value)
        }
        else if(option == "number"){
            $("#nobins").val(value);
        }

        makeimage();
    });

    //finalbinnumber
    $("#finalbinnumber").on("click", function(){
        $(".finalchoosebinnumber").show();
    });

    $(".finalchoosebinnumber").on("click","li", function(){
        let value = $(this).data('value');
        $(".finalchoosebinnumber").hide();
        $("#finalbinnumber").html("x"+value);
        $("#nobins").val(value);

        $(".finalchoosebinnumber").find("li").each(function(){
            if($(this).data('value')!=value){
                $(this).removeClass('selected');
            }
            else{
                $(this).addClass('selected');
            }
        });

        $(".choosebinnumber").each(function(){
            if($(this).data('option')=="number"){
                if($(this).data('value')==value){
                    $(this).addClass('selected');
                }
                else{
                    $(this).removeClass('selected');
                }
            }
        });

        makeimage();
        makelink();
    });

    //finalbinsize
    $("#finalbinsize").on("click", function(){
        $(".finalchoosebinsize").show();
    });

    $(".finalchoosebinsize").on("click","li", function(){
        let value = $(this).data('value');
        $(".finalchoosebinsize").hide();
        $("#finalbinsize").html(value+"l");
        $("#binsize").val(value);

        $(".finalchoosebinsize").find("li").each(function(){
            if($(this).data('value')!=value){
                $(this).removeClass('selected');
            }
            else{
                $(this).addClass('selected');
            }
        });

        $(".choosebinnumber").each(function(){
            if($(this).data('option')=="litraza"){
                if($(this).data('value')==value){
                    $(this).addClass('selected');
                }
                else{
                    $(this).removeClass('selected');
                }
            }
        });

        makeimage();
        makelink();
    });

    //showstep3
    function showstep3(){
        let model = $("#model").val();
        $(".modelname").each(function( index ) {
            $(this).html(model.toUpperCase());
        });

        makeimage();
        $(".step3").show();
    }
    function showstep7(){

        let model = $("#model").val();
        let doorname = $("#doorchoosen").val();
        $("#doorname").html(doorname.toUpperCase());

        //select door type
        $(".doorfinalcoose").find('.doorchoose').each(function( index ) {
            if($(this).data('door')==doorname){
                $(this).addClass('selected');
            }
            else{
                $(this).removeClass('selected');
            }
        });

        //
        $(".modelnamechoose").each(function( index ) {
            if($(this).data('name')==model){
                $(this).addClass('selected');
            }
            else{
                $(this).removeClass('selected');
            }
        });
        //add choosen values
        $("#finalbinnumber").html("x"+$("#nobins").val());
        $("#finalbinsize").html($("#binsize").val()+"l");

        makelink();
    }
    function makelink(){
        let model = $("#model").val();
        let colorchoosen = $("#colorshooen").val();
        let doorchoosen = $("#doorchoosen").val();
        let equipmentchoosen = $("#equipmentchoosen").val();
        let binsize = $("#binsize").val();
        let nobins = $("#nobins").val();

        let linkvalue = "";
        let productlink = "";

        linkvalue = colorchoosen+"-"+nobins+"x"+binsize+"-"+doorchoosen+"-link";


        if(model=="classic"){
            productlink = classic[linkvalue];
        }
        else if(model=="linis"){
            productlink = linis[linkvalue];
        }

        $(".viewproductlink").attr("href", productlink);

        let choosed = $("#model").val()+"|"+$("#colorshooen").val()+"|"+$("#doorchoosen").val()+"|"+$("#binsize").val()+"|"+$("#nobins").val()+"|"+$("#imagechoosen").val();
        sessionStorage.setItem("choosed", choosed);

    }
    function makename(){
        let model = $("#model").val();
        let doorchoosen = $("#doorchoosen").val();
        let doorname="";
        let binsize = $("#binsize").val();
        let nobins = $("#nobins").val();

        if(doorchoosen == "basic"){
            if(model=="linis"){
                doorname = "D0";
            }
            else{
                doorname = "Blank";
            }

        }
        else{
            doorname = doorchoosen;
        }

        let name = "StyleOUT ";
        name = name + model.charAt(0).toUpperCase() + model.slice(1)+" "+nobins+"x"+binsize+" "+ doorname.charAt(0).toUpperCase() + doorname.slice(1);
        $("#doorname").html(doorname.charAt(0).toUpperCase() + doorname.slice(1));

        $(".finalmodelname").html(name);

        //make dimension
        let dimension = dimensions[nobins+'x'+binsize];
        $(".technicalimg").html("<img src='"+dimension+"'/>");
    }
    function makeimage(){
        let model = $("#model").val();
        let colorchoosen = $("#colorshooen").val();
        let doorchoosen = $("#doorchoosen").val();
        let equipmentchoosen = $("#equipmentchoosen").val();
        let binsize = $("#binsize").val();
        let nobins = $("#nobins").val();

        let img = "";
        let imagelink = "";

        img = colorchoosen+"-"+nobins+"x"+binsize+"-"+doorchoosen;

        if(model=="classic"){
            imagelink = classic[img];
        }
        else if(model=="linis"){
            imagelink = linis[img];
        }

        $("#modelview").html("<img src='"+imagelink+"'/>");

        $(".importmodelview").each(function( index ) {
            $(this).html("<img src='"+imagelink+"'/>");
        });
        makename();
    }

    //PAGE PRODUCT
    $(".dropdownheader").on("click", function(){
        let self =  $(this);
        let openid = $(this).data('id');

        $("#"+openid).toggleClass("open");
    });

    if ($(".product-form__input")[0]) {
        $(".product-form__input").find("label").each(function (index) {
            let self = $(this);
            let content = $.trim($(this).html()).toLowerCase();
            if(content=="locking option"){
                self.html("<img src='https://cdn.shopify.com/s/files/1/0617/4569/2920/files/kljuc.png?v=1643041535'/><span>"+self.html()+"</span>");
            }
            else if(content=="retractable roof"){
                self.html("<img src='https://cdn.shopify.com/s/files/1/0617/4569/2920/files/streha.png?v=1643041535'/><span>"+self.html()+"</span>");
            }
        });
    }

    $(".dropdowncontent").on("click","a", function(e){
        let self=$(this);
        if (/#/.test(this.href)) {
            e.preventDefault();
            //open modal
            let modalid = self.attr('href');
            $(modalid).attr('open', true);
        }
    });

    $(".viewproduct").on("click", function(e){
      e.preventDefault();
      $("iframe").css('opacity',"0");
            let producturl = $("#modal-signup-custom-field-1");
            let productimage = $("#modal-signup-custom-field-2");
            let productname = $("#modal-signup-custom-field-3");
            let bin_color = $("#modal-signup-custom-field-6");
            let bin_size = $("#modal-signup-custom-field-5");
            let no_bins = $("#modal-signup-custom-field-4");

            let model = $("#model").val();
            let colorchoosen = $("#colorshooen").val();
            let doorchoosen = $("#doorchoosen").val();
            let equipmentchoosen = $("#equipmentchoosen").val();
            let binsize = $("#binsize").val();
            let nobins = $("#nobins").val();

            let img = "";
            let imagelink = "";

            img = colorchoosen+"-"+nobins+"x"+binsize+"-"+doorchoosen;

            if(model=="classic"){
                imagelink = classic[img];
            }
            else if(model=="linis"){
                imagelink = linis[img];
            }

            let linkvalue = "";
            let productlink = "";

            linkvalue = colorchoosen+"-"+nobins+"x"+binsize+"-"+doorchoosen+"-link";

            


            if(model=="classic"){
                productlink = classic[linkvalue];
            }
            else if(model=="linis"){
                productlink = linis[linkvalue];
            }

            producturl.val(productlink);
            productimage.val(imagelink);
            bin_color.val(colorchoosen);
            bin_size.val(binsize);
            no_bins.val(nobins);


            window.location.href = productlink;
            /*

            productname.val($(".finalmodelname").html());

            $('html').find('.ocp__modal__link__3Ae0PAcgca90sfsFX6-Hw-').hide();
            $('html').find(".ocp__modal__btn__secondary__2UyyJO0_PQUjay5rp9gb7w").html('<button class="closeandfinish">No, thanks</button>');

            if($('html').find("#modal-success-main-content").length > 0) {
                $('html').find(".ocp__modal__btn__XJPJfr0EXQsYdmolbgI95").hide();
                $('html').find("#modal-success-main-content").append("<div class='continueshopping'>Continue Shopping</div>");
            }
          */

    });



    if($(".deferred-media__poster-button").length>0){
        $(".deferred-media__poster-button").click();
    }

    //Checkout
    if($(".product-form__submit").length>0){
        $(".product-form__submit").find('span').html('BUY');
    }
    $(".mobileopendimensions").on('click', function(){
        $(".technicalimg").toggle();
        setTimeout(function() {
            if ($('#techlink:visible').length == 1) {
                $('.step7').find(".movers").css('height','270px');
            }
            else{
                $('.step7').find(".movers").css('height','70px');
            }
        },200);
    });

    if($(".choosebinencloser").length > 0){
        setTimeout(function() {
            var position = $(".choosebinencloser").first().offset().top;
            console.log(position);
        },300);
    }
});